import * as React from 'react';
export const bnpparibasSvg = React.forwardRef(function bnpparibasSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#00965E',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'm6.46 19.6 1.27 1.97h1.91L9 23.53l1.28 1.32H8.37v1.3L7.1 24.2l-1.91-1.31 1.27-.66V19.6zm7 5.25h1.9l1.28-1.32v1.32l1.27-1.32-1.27 1.97v.66h-1.28l-1.9.65.63-.65-.63-1.31zM7.1 16.98l2.54-3.93-2.54-1.3h4.45l1.9-1.32v1.97l3.19 1.3h-4.46l-.63 3.28-1.27-2.62-3.18 2.62zm12.08-11.8 5.09 1.97h2.54l-1.27 1.32-.64 5.24-1.27-4.59-3.18 1.97 1.27-2.62-5.08.65 5.08-1.31-2.54-2.62z',
      }),
    ),
  );
});
bnpparibasSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var bnpparibas = {
  category: 'brand',
  colorable: false,
  name: 'bnpparibas',
  svg: bnpparibasSvg,
};
